import React from 'react';
import { WrenchScrewdriverIcon } from '@heroicons/react/24/solid';

interface MaintenancePageProps {
  message?: string;
}

const MaintenancePage: React.FC<MaintenancePageProps> = ({ message }) => (
  <div style={{
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    minHeight: '100vh', margin: 0,
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
    color: 'white',
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  }}>
    <div style={{ textAlign: 'center', maxWidth: 520, padding: '40px 24px' }}>
      <WrenchScrewdriverIcon style={{ width: 56, height: 56, color: '#f59e0b', marginBottom: 24 }} />
      <h1 style={{ fontSize: '1.75rem', fontWeight: 700, marginBottom: 16 }}>
        We'll Be Right Back
      </h1>
      <p style={{ color: 'rgba(255,255,255,0.6)', lineHeight: 1.7, fontSize: '1.05rem', marginBottom: 0 }}>
        {message || 'We are currently performing scheduled maintenance. Please check back shortly.'}
      </p>
    </div>
  </div>
);

export default MaintenancePage;
